"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _emit = require("./emit");
Object.keys(_emit).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _emit[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _emit[key];
    }
  });
});